import ptBR from "./pt-br";

export default {
  "pt-br": ptBR,
};
